import { Tooltip as TT } from '@base-ui-components/react/tooltip';
import classNames from 'classnames';
import { FC } from 'react';
import { TooltipArrowIcon } from 'utils/icons/figmaIcons';

type TooltipProps = {
  children: React.ReactElement;
  content: React.ReactNode;
  rootProps?: TT.Root.Props;
  positionProps?: TT.Positioner.Props;
  hideArrow?: boolean;
  contentWrapperClassName?: string;
};

const transitionsClasses = [
  'data-[ending-style]:data-[side=top]:translate-y-2 data-[starting-style]:data-[side=top]:translate-y-2',
  'data-[ending-style]:data-[side=bottom]:translate-y-2 data-[starting-style]:data-[side=bottom]:translate-y-2',
  'data-[ending-style]:data-[side=left]:-translate-x-2 data-[starting-style]:data-[side=left]:-translate-x-2',
  'data-[ending-style]:data-[side=right]:translate-x-2 data-[starting-style]:data-[side=right]:translate-x-2',
];

const Tooltip: FC<TooltipProps> = ({
  children,
  content,
  rootProps,
  positionProps,
  hideArrow,
  contentWrapperClassName,
}) => {
  return (
    <TT.Provider>
      <TT.Root delay={0} hoverable={false} {...rootProps}>
        <TT.Trigger render={children} />
        <TT.Portal>
          <TT.Positioner sideOffset={10} className="z-[100]" {...positionProps}>
            <TT.Popup
              className={classNames(
                'transition-[transform,opacity] data-[ending-style]:opacity-0 data-[instant]:duration-0 data-[starting-style]:opacity-0',
                transitionsClasses,
              )}
            >
              {!hideArrow && (
                <TT.Arrow className="pointer-events-none data-[side=bottom]:top-[-7px] data-[side=left]:right-[-13px] data-[side=left]:rotate-90 data-[side=right]:left-[-7px] data-[side=right]:-rotate-90 data-[side=top]:bottom-[-7px] data-[side=top]:rotate-180">
                  <TooltipArrowIcon className="pointer-events-none w-[20px] h-[10px] text-[#374151]" />
                </TT.Arrow>
              )}
              <div
                className={classNames(
                  'max-w-[16rem] text-sm font-semibold p-2 bg-[#374151] rounded-lg text-white',
                  contentWrapperClassName,
                )}
              >
                {content}
              </div>
            </TT.Popup>
          </TT.Positioner>
        </TT.Portal>
      </TT.Root>
    </TT.Provider>
  );
};

export default Tooltip;
